import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function MinhaAssinatura() {
  const { assinatura, carregarPerfil, emTrial, diasTrial } = useAuth();

  const cancelar = async () => {
    if (!window.confirm('Tem certeza que deseja cancelar? Você perderá o acesso imediatamente.')) return;
    try {
      await api.post('/assinaturas/cancelar');
      await carregarPerfil();
    } catch (err) { alert(err.response?.data?.error || 'Erro ao cancelar.'); }
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString('pt-BR') : '—';
  const isTrial = emTrial();
  const dias    = diasTrial();

  const S = {
    page: { background: 'var(--cream)', minHeight: 'calc(100vh - 112px)', padding: '56px 0' },
    wrap: { maxWidth: 600 },
    trialBanner: {
      background: 'linear-gradient(135deg,rgba(216,189,105,.2),rgba(154,86,55,.1))',
      border: '1px solid rgba(216,189,105,.4)', borderRadius: 'var(--r-md)',
      padding: '22px 26px', marginBottom: 24, display: 'flex', gap: 16, alignItems: 'flex-start',
    },
    trialDays: {
      background: 'var(--rust)', color: '#fff', borderRadius: 'var(--r-sm)',
      padding: '6px 14px', fontSize: 11, fontWeight: 900, letterSpacing: 1,
      textTransform: 'uppercase', flexShrink: 0, alignSelf: 'flex-start', marginTop: 2,
    },
    infoGrid: {
      display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16,
      background: 'var(--cream-dark)', borderRadius: 'var(--r-sm)', padding: 20, marginBottom: 24,
    },
    infoCell: {},
    infoLabel: { fontSize: 9, letterSpacing: 1.6, textTransform: 'uppercase', color: 'var(--rust)', fontWeight: 900, marginBottom: 5 },
    infoValue: { fontSize: 15, fontWeight: 700 },
    actions: { display: 'flex', gap: 12, flexWrap: 'wrap' },
  };

  return (
    <>
      <Navbar />
      <div style={S.page}>
        <div className="container" style={S.wrap}>
          <div className="page-header">
            <div className="eyebrow">Minha conta</div>
            <h1 className="section-title">Minha assinatura</h1>
            <div className="gold-rule" />
          </div>

          {assinatura ? (
            <div className="card" style={{ padding: '32px 36px' }}>

              {/* Banner trial */}
              {isTrial && (
                <div style={S.trialBanner}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 600, marginBottom: 6 }}>
                      Período de teste ativo
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--ink-muted)', lineHeight: 1.6 }}>
                      Você está usando o Heritage gratuitamente. A primeira cobrança de{' '}
                      <strong style={{ color: 'var(--ink)' }}>R$ {Number(assinatura.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong>{' '}
                      será em <strong style={{ color: 'var(--ink)' }}>{fmt(assinatura.data_renovacao)}</strong>. Cancele antes dessa data sem nenhum custo.
                    </div>
                  </div>
                  <div style={S.trialDays}>{dias}d restantes</div>
                </div>
              )}

              {/* Header plano */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
                <div>
                  <div style={{ fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--rust)', fontWeight: 900, marginBottom: 8 }}>Plano atual</div>
                  <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, fontWeight: 600 }}>{assinatura.plano_nome}</div>
                  <div style={{ fontSize: 22, fontWeight: 900, color: 'var(--rust)', marginTop: 4 }}>
                    R$ {Number(assinatura.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}<span style={{ fontSize: 14, color: 'var(--ink-muted)', fontWeight: 400 }}>/mês</span>
                  </div>
                </div>
                <span className={`badge badge-${isTrial ? 'trial' : assinatura.status}`}>
                  {isTrial ? 'Trial ativo' : assinatura.status}
                </span>
              </div>

              {/* Datas */}
              <div style={S.infoGrid}>
                {assinatura.data_inicio && (
                  <div style={S.infoCell}>
                    <div style={S.infoLabel}>Início</div>
                    <div style={S.infoValue}>{fmt(assinatura.data_inicio)}</div>
                  </div>
                )}
                <div style={S.infoCell}>
                  <div style={S.infoLabel}>{isTrial ? 'Primeira cobrança' : 'Próxima renovação'}</div>
                  <div style={S.infoValue}>{fmt(assinatura.data_renovacao)}</div>
                </div>
              </div>

              {/* Ações */}
              <div style={S.actions}>
                {assinatura.plano_slug === 'basico' && (
                  <Link to="/checkout?plano=premium" className="btn btn-primary">Fazer upgrade para Premium</Link>
                )}
                <button
                  onClick={cancelar}
                  className="btn btn-outline"
                  style={{ borderColor: '#be2e2e', color: '#be2e2e' }}>
                  {isTrial ? 'Cancelar (sem custo)' : 'Cancelar assinatura'}
                </button>
              </div>

              {isTrial && (
                <p style={{ fontSize: 12, color: 'var(--ink-muted)', marginTop: 16, lineHeight: 1.5 }}>
                  ✓ Cancelar durante o período de teste é gratuito e imediato. Nenhum valor será cobrado.
                </p>
              )}
            </div>
          ) : (
            <div className="card" style={{ padding: 48, textAlign: 'center' }}>
              <div style={{ fontSize: 44, marginBottom: 20 }}>📋</div>
              <p style={{ color: 'var(--ink-muted)', marginBottom: 24, lineHeight: 1.6 }}>Você não possui uma assinatura ativa no momento.</p>
              <Link to="/planos" className="btn btn-primary">Ver planos disponíveis</Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
